import { css } from '@emotion/react'
import { Cell, Heading, Theme, useTheme, VFlow } from 'bold-ui'
import { ReactElement } from 'react'

interface HistoricoMedicoesDataTableProps {
  titulo: string
  children: ReactElement
}

export default function HistoricoMedicoesDataTable(props: Readonly<HistoricoMedicoesDataTableProps>) {
  const { titulo, children } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <VFlow vSpacing={0.5}>
      <Cell css={styles.tableHeader}>
        <Heading level={5}>{titulo}</Heading>
      </Cell>
      {children}
    </VFlow>
  )
}

const createStyles = (theme: Theme) => ({
  tableHeader: css`
    border-top: 1px solid ${theme.pallete.gray.c80};
    border-left: 1px solid ${theme.pallete.gray.c80};
    border-right: 1px solid ${theme.pallete.gray.c80};
    padding: 0.5rem 1rem;
    margin-bottom: -0.5rem;
  `,
})
